import { Component, EventEmitter, Input, Output } from '@angular/core';
import { Link } from '../../models/links.model.interface';
import * as CDN_FILES from '../../constants/cdn-files';
@Component({
  selector: 'app-header',
  templateUrl: './header.component.html',
  styleUrls: ['./header.component.scss'],
})
export class HeaderComponent {
  logoGsc = CDN_FILES.groupLogo;
  logoGscMobile = CDN_FILES.groupLogoMobile;
  @Input() items: Link[];
  @Input() showSearchField = false;
  @Output() search: EventEmitter<string> = new EventEmitter<string>();
  placeholder = 'Buscar';

  searchBenefits(event: string) {
    this.search.emit(event);
  }

  searchWhenTextChange(event: string) {
    if (!event) {
      this.search.emit('');
    }
  }
}
